<template>
    <form-panel :title="title">
        <template v-slot:headerActions>
            <v-btn small outlined color="success" @click="addContact">
                <v-icon left>add</v-icon>
                {{ $t('actions.add') }}
            </v-btn>
        </template>

        <draggable v-model="model" handle=".handle">
            <div
                v-for="(contact, index) in model"
                :key="`${name}-${index}`"
                class="one-contact-wrapper"
            >
                <div class="handle">
                    <v-icon> drag_indicator</v-icon>
                </div>
                <OneContact
                    :contact="contact"
                    :index="index"
                    :name="name"
                    :error-messages="errorMessages"
                    @remove="removeContact"
                    @blur-phone="formatPhone"
                />
            </div>
        </draggable>
    </form-panel>
</template>

<script>
import FormInput from '@/components/mixins/FormInput'
import PhoneNumberMixin from '@/components/mixins/PhoneNumberMixin'
import FormPanel from '@/components/form/FormPanel'
import OneContact from '@/components/elements/OneContact'
import Draggable from 'vuedraggable'

export default {
    components: {
        FormPanel,
        OneContact,
        Draggable,
    },
    inject: {
        $validator: 'formValidator',
    },
    mixins: [FormInput, PhoneNumberMixin],
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            model: [],
            errorMessages: [],
        }
    },
    methods: {
        addContact() {
            this.model.push({ name: '', email: '', phone: '' })
        },
        removeContact(index) {
            this.model.splice(index, 1)
        },
        formatPhone(index, phone) {
            this.model[index].phone = this.formatPhoneNumber(phone)
        },
    },
}
</script>
